var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlRoomsIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659 587.997L658.315 340L604.921 367.098V587.997C604.921 597.601 597.391 605.147 587.807 605.147C578.223 605.147 570.693 597.601 570.693 587.997V456.624C570.693 417.52 538.862 385.62 499.5 385.62C460.138 385.62 428.307 417.52 428.307 456.624V587.997C428.307 597.601 420.777 605.147 411.193 605.147C401.609 605.147 394.079 597.601 394.079 587.997V472.402L340 499.5V587.997C340 627.1 371.832 659 411.193 659C450.555 659 482.386 627.1 482.386 587.997V456.624C482.386 447.019 489.916 439.473 499.5 439.473C509.084 439.473 516.614 447.019 516.614 456.624V587.997C516.614 627.1 548.445 659 587.807 659C627.168 659 659 627.1 659 587.997Z",
    fill: "#F9FAF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlRoomsIconWhite);
export default __webpack_public_path__ + "static/media/ControlRoomsIconWhite.ecff8c89c8afa4e9ae64958900d4e290.svg";
export { ForwardRef as ReactComponent };